import LayoutPrimary from '../../layouts/Primary';
import ProfessionIndex from '../../views/Admin/Config/Profession/ProfessionIndex';
import ProfessionEdit from '../../views/Admin/Config/Profession/ProfessionEdit';
import ProfessionCreate from '../../views/Admin/Config/Profession/ProfessionCreate';

export default [
    {
        path: '/specialty/create',
        name: 'ProfessionCreate',
        component: ProfessionCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary
        }
    },
    {
        path: '/specialty/index',
        name: 'ProfessionIndex',
        component: ProfessionIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary
        },
        props: true
    },
    {
        path: '/specialty/edit/:id',
        name: 'ProfessionEdit',
        component: ProfessionEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary
        }
    }
];
